module.exports = __webpack_public_path__ + "img/phone_screen_03@2x.92997be3.png";